/**
 * A one-time healing pickup — sits idle until the player touches it, heals
 * a percentage of the player's current max HP (see PickupSystem's
 * HEAL_PERCENT), then despawns permanently (no respawn at that spot).
 */
export class HealthPod {
  constructor({ x, y, radius = 20 }) {
    this.x = x;
    this.y = y;
    this.radius = radius;
    this.active = true;
  }
}
